export const LEGAL_VERSION = "2026-08-17";
export const GOOGLE_ANALYTICS_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
export const GOOGLE_ANALYTICS_ENABLED = Boolean(GOOGLE_ANALYTICS_ID);

const configuredValue = (name) => {
  const value = (process.env[name] || "").trim();
  return value || `[PENDING: ${name}]`;
};

export const LEGAL_IDENTITY = {
  brand: "Guía Emprendedor",
  holder: configuredValue("REACT_APP_LEGAL_HOLDER"),
  taxId: configuredValue("REACT_APP_LEGAL_TAX_ID"),
  address: configuredValue("REACT_APP_LEGAL_ADDRESS"),
  registry: configuredValue("REACT_APP_LEGAL_REGISTRY"),
  email: process.env.REACT_APP_LEGAL_EMAIL?.trim() || "info@guia-emprendedor.com"
};

export const LEGAL_IDENTITY_COMPLETE = !Object.values(LEGAL_IDENTITY).some(
  (value) => typeof value === "string" && value.startsWith("[PENDING:")
);
